import { graphql } from "~/gql/gql";

export const UPDATE_MATTER = graphql(/* GraphQL */ `
  mutation updateMatter($id: Float!, $data: MatterUpdateInput!) {
    updateMatter(id: $id, data: $data) {
      __typename
      id
      reference
      title
      status
      reference
      createdAt
      updatedAt
      template
      parentMatterId
      parent {
        id
        title
        matters {
          id
          title
        }
      }
      externalMatterId
      externalMatter {
        id
        title
        status
        leadFeeEarner {
          id
          name
        }
        client {
          id
          name
          externalReference
          type
        }
        externalReference
        organisationalUnit {
          __typename
          id
          name
          parent {
            id
            name
          }
        }
      }
      externalReference
      createdBy {
        id
        userName
        displayName
      }
      client {
        id
        name
        externalReference
        type
      }
      priceOptions {
        estimatedGpm
        estimatedSuggested
        estimatedChosen
        estimatedRangeGpm
        estimatedRangeSuggestedLower
        estimatedRangeSuggestedUpper
        estimatedRangeChosenLower
        estimatedRangeChosenUpper
        fixedGpm
        fixedSuggested
        fixedChosen
        cappedChosen
        cappedGpm
        cappedSuggested
        feeRiskLower
        feeRiskUpper
        topDownFeeTarget
        topDownHoursTarget
        topDownRateDiscount
      }
      disbursements {
        __typename
        autoFocus @client
        id
        name
        amount
        vatStatus
        order
      }
      uplifts {
        __typename
        autoFocus @client
        id
        amount
        type
        order
        baseUplift {
          id
          reason
        }
      }
      discounts {
        __typename
        autoFocus @client
        id
        reason
        amount
        type
        order
      }
      phases {
        __typename
        autoFocus @client
        id
        title
        description
        order
        priceOptions {
          estimatedGpm
          estimatedSuggested
          estimatedChosen
          estimatedRangeGpm
          estimatedRangeSuggestedLower
          estimatedRangeSuggestedUpper
          estimatedRangeChosenLower
          estimatedRangeChosenUpper
          fixedGpm
          fixedSuggested
          fixedChosen
          cappedChosen
          cappedGpm
          cappedSuggested
        }
        __typename
        id
        title
        order
        work {
          __typename
          id
          phaseId
          timeLower
          timeUpper
          timeSingle
          price {
            lower
            upper
            single
          }
          selectedRate {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
          }
          feeEarnerLevel {
            id
            description
            order
          }
          feeEarner {
            id
            name
            feeEarnerLevel {
              id
              description
              order
            }
            practiceArea {
              id
              name
            }
          }
          cost {
            lower
            upper
            single
          }
          costRate
          price {
            lower
            upper
            single
          }
        }
      }
      organisationalUnit {
        __typename
        id
        name
        parent {
          id
          name
        }
      }
      leadFeeEarner {
        __typename
        id
        name
        feeEarnerLevel {
          id
        }
      }
      pricingType
      pricingLevel
      pricingTarget
      taxStatus
      includeTasksInProposalOutput
      includeRatesInProposalOutput
      waiveAdminCharge
      work {
        __typename
        id
        phaseId
        timeLower
        timeUpper
        timeSingle
        workEffort
        topDownRateDiscount
        price {
          lower
          upper
          single
        }
        selectedRate {
          id
          description
          amount
          clientId
          feeEarnerId
          feeEarnerLevelId
          deprecated
          currency {
            id
            code
            symbol
          }
        }
        feeEarnerLevel {
          id
          description
          order
        }
        feeEarner {
          id
          name
          deprecated
          feeEarnerLevel {
            id
            description
            order
          }
          rates {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
            deprecated
            currency {
              id
              code
              symbol
            }
          }
          practiceArea {
            id
            name
          }
        }
        cost {
          lower
          upper
          single
        }
        costRate
        price {
          lower
          upper
          single
        }
      }
      startDate
      deadlineDate
    }
  }
`);
